import { FormAtylBase } from '../../form-atyl-base'

export class AtylSelectionList extends FormAtylBase<string> {
	controlType = 'selectionlist'
	type: string

	constructor(options: {} = {}) {
		super(options)
		this.type = options['type'] || ''
	}
}
